/* CNOIR — suit Fitting Room collection page (2026-10-24). Fabric picker re-prices AND filters to suits offered in that fabric; "All fabrics" default; filters, sort, saved suits. */
(function () {
  var KEY_FAB = 'cnoir-suit-fabric-v2', KEY_SAVED = 'cnoir-saved-suits';
  function get(k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  }

  function init(root) {
    var grid = root.querySelector('[data-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    if (!grid || !cards.length) return;
    var seg = root.querySelector('[data-fab-seg]'), panel = root.querySelector('[data-fab-panel]');
    var sortSel = root.querySelector('[data-sort]'), countEl = root.querySelector('[data-count]');
    var emptyEl = root.querySelector('[data-empty]'), savedChip = root.querySelector('[data-chip="__saved"]');
    var savedN = root.querySelector('[data-saved-n]'), dockSaved = root.querySelector('[data-dock-saved]');
    var saved = get(KEY_SAVED, []);
    var state = { chip: '', sort: 'feat', fab: null };

    // per-card fabric tiers, sorted by price
    cards.forEach(function (c) {
      var t = [];
      try { t = JSON.parse(c.getAttribute('data-tiers')) || []; } catch (e) {}
      t.sort(function (a, b) { return a[1] - b[1]; });
      c._t = t; c._lo = t.length ? t[0][1] : 0;
    });

    // fabric union for this page: name -> lowest price, ordered by price
    var fab = {};
    cards.forEach(function (c) { c._t.forEach(function (x) { if (!(x[0] in fab) || x[1] < fab[x[0]]) fab[x[0]] = x[1]; }); });
    var fabs = Object.keys(fab).map(function (n) { return { n: n, v: fab[n] }; }).sort(function (a, b) { return a.v - b.v; });
    var remembered = get(KEY_FAB, null);
    state.fab = fabs.some(function (f) { return f.n === remembered; }) ? remembered : '';

    if (seg && fabs.length > 1) {
      seg.innerHTML = '<button type="button" data-fab="" aria-pressed="false">All fabrics<small>from ' + money(fabs[0].v) + '</small></button>' + fabs.map(function (f) {
        return '<button type="button" data-fab="' + f.n.replace(/"/g, '&quot;') + '" aria-pressed="false">' + f.n.replace(/</g, '&lt;') + '<small>from ' + money(f.v) + '</small></button>';
      }).join('');
      panel.hidden = false;
    }

    function paintPrices() {
      if (seg) Array.prototype.forEach.call(seg.children, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-fab') === state.fab)); });
      cards.forEach(function (c) {
        var t = c._t, k = -1;
        for (var i = 0; i < t.length; i++) if (t[i][0] === state.fab) k = i;
        var price = c.querySelector('[data-price]'), nm = c.querySelector('[data-fabname]'), lad = c.querySelector('[data-ladder]');
        if (!t.length) return;
        if (k >= 0) { price.textContent = money(t[k][1]); nm.textContent = t[k][0]; }
        else { price.textContent = money(t[0][1]); nm.textContent = 'from · ' + t[0][0]; }
        if (lad) {
          var on = k >= 0 ? k : 0, h = '';
          for (var j = 0; j < t.length; j++) h += '<i' + (j <= on ? ' class="on"' : '') + '></i>';
          lad.innerHTML = h;
        }
      });
    }

    function paintSaved() {
      cards.forEach(function (c) {
        var b = c.querySelector('[data-save]');
        if (b) b.setAttribute('aria-pressed', String(saved.indexOf(c.getAttribute('data-handle')) > -1));
      });
      var n = cards.filter(function (c) { return saved.indexOf(c.getAttribute('data-handle')) > -1; }).length;
      if (savedChip) { savedChip.hidden = n === 0 && state.chip !== '__saved'; }
      if (savedN) savedN.textContent = n;
      if (dockSaved) dockSaved.textContent = n ? '· ' + n + ' saved' : '';
    }

    function apply() {
      var re = null;
      if (state.chip && state.chip !== '__saved') {
        try { re = new RegExp(state.chip, 'i'); } catch (e) { re = null; }
      }
      var shown = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (state.chip === '__saved') ok = saved.indexOf(c.getAttribute('data-handle')) > -1;
        else if (re) ok = re.test(c.getAttribute('data-title'));
        if (ok && state.fab) ok = c._t.some(function (x) { return x[0] === state.fab; });
        c.hidden = !ok; if (ok) shown++;
      });
      var order = cards.slice();
      if (state.sort === 'lo') order.sort(function (a, b) { return a._lo - b._lo || a.dataset.i - b.dataset.i; });
      else if (state.sort === 'hi') order.sort(function (a, b) { return b._lo - a._lo || a.dataset.i - b.dataset.i; });
      else order.sort(function (a, b) { return a.dataset.i - b.dataset.i; });
      order.forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = shown;
      if (emptyEl) emptyEl.hidden = shown > 0;
      root.querySelectorAll('[data-chip]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-chip') === state.chip)); });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-fab')) { state.fab = b.getAttribute('data-fab'); put(KEY_FAB, state.fab); paintPrices(); apply(); return; }
      if (b.hasAttribute('data-chip')) { state.chip = b.getAttribute('data-chip'); apply(); paintSaved(); return; }
      if (b.hasAttribute('data-reset')) { state.chip = ''; state.fab = ''; put(KEY_FAB, ''); paintPrices(); apply(); paintSaved(); return; }
      if (b.hasAttribute('data-save')) {
        e.preventDefault();
        var h = b.closest('[data-card]').getAttribute('data-handle'), i = saved.indexOf(h);
        if (i > -1) saved.splice(i, 1); else saved.push(h);
        put(KEY_SAVED, saved); paintSaved();
        if (state.chip === '__saved') apply();
      }
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });

    // keep the filter bar below a sticky site header
    var bar = root.querySelector('[data-bar]');
    function offset() {
      var hdr = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header');
      var top = 0;
      if (hdr) {
        var cs = getComputedStyle(hdr.closest('.section-header') || hdr);
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          var r = hdr.getBoundingClientRect();
          if (!(hdr.closest('.shopify-section-header-hidden'))) top = Math.max(0, r.bottom);
        }
      }
      if (bar) root.style.setProperty('--csr-top', top + 'px');
    }
    offset();
    window.addEventListener('scroll', offset, { passive: true });
    window.addEventListener('resize', offset);

    paintPrices(); paintSaved(); apply();
  }

  function boot() { document.querySelectorAll('[data-csr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
